import StarterKit from "./StarterKit";

import Header from "./components/Header";
import NavsFull from "./components/NavsFull";
import NavsBurger from "./components/NavsBurger";
import StickyCTA from './components/StickyCTA';
import CursorMagnetEffect from './animations/CursorMagnetEffect';

import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockGallery from "./blocks/BlockGallery";
import BlockGallerySlider from "./blocks/BlockGallerySlider";
import BlockGallerySliderSimple from "./blocks/BlockGallerySliderSimple";
import BlockMap from "./blocks/BlockMap";
import BlockMovie from "./blocks/BlockMovie";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSlider from "./blocks/BlockSlider";
import BlockSliderScrollable from "./blocks/BlockSliderScrollable";
import BlockScrollingText from "./blocks/BlockScrollingText";
import BlockUpcomingNewsAndEvents from './blocks/BlockUpcomingNewsAndEvents';
import EventsListEntry from './blocks/EventsListEntry';

import Share from "./components/Share";
import TextHighlightedBackground from './components/TextHighlightedBackground';
import BlockKeyNumbers from './blocks/BlockKeyNumbers';
import BlockListingLinks from './blocks/BlockListingLinks';
import BlockMilestones from './blocks/BlockMilestones';
import BlockPeople from "./blocks/BlockPeople";

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	Header.init();
	NavsFull.init();
	NavsBurger.init();
	StickyCTA.init();
	TextHighlightedBackground.init();
	CursorMagnetEffect.init();

	// Blocks
	BlockBanner.init();
	BlockCollapse.init();
	BlockGallery.init();
	BlockGallerySlider.init();
	BlockGallerySliderSimple.init();
	BlockKeyNumbers.init();
	BlockListingLinks.init();
	BlockMap.init();
	BlockMilestones.init();
	BlockPeople.init();
	BlockMovie.init();
	BlockQuotes.init();
	BlockSlider.init();
	BlockScrollingText.init();
	BlockSliderScrollable.init();
	BlockUpcomingNewsAndEvents.init();
	EventsListEntry.init();
	Share.init();
});
